import * as angular from "angular";
import {IController} from "angular";

export class RulesTableComponent implements IController {

  infiniteScroll: any;
  onEditRule: Function;
  onDeleteRule: Function;

}


angular
  .module('bringoz.admin.ruleEngine')
  .component('rulesTable', {
    bindings: {
      infiniteScroll: '<',
      onEditRule: '&',
      onDeleteRule: '&'
    },
    template: require('./rules-table.html').default,
    controller: RulesTableComponent
  });

